import React from "react";
import Chevron from "@icons/Chevron";
import { Box, Typography } from "@mui/material";
import Link from "next/link";
import { TypographyProps } from "@mui/system";

export interface LinkMoreProps extends TypographyProps {
  text: string;
  href?: string;
  withIcon?: boolean;
  onClick?: () => void;
}

export const LinkMore: React.FC<LinkMoreProps> = ({ text, href, withIcon, onClick }) => {
  const content = (
    <Typography
      variant="body1"
      color="primary.main"
      fontWeight="bold"
      display="inline-flex"
      alignItems="center"
      sx={{ svg: { width: "10px", verticalAlign: "middle", marginLeft: "10px" } }}
    >
      <span>{text}</span>
      {withIcon && <Chevron />}
    </Typography>
  );

  if (href) {
    return (
      <Link href={href}>
        <a>{content}</a>
      </Link>
    );
  }

  return (
    <Box onClick={onClick} sx={{ cursor: "pointer" }}>
      {content}
    </Box>
  );
};
